import * as React from "react";
import PropTypes from "prop-types";
import ArrowIcon from "@material-ui/icons/KeyboardArrowRight";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import TSideDrawer from "../../common/TSideDrawer";
import TBox from "../../common/TBox";
import * as HLConst from "../NonVisual/HLConst";
import * as Theme from "../../../app/Theme";

// const indent1 = 20;
const indent2 = 40;

const menuItemStyle = {
    cursor: "pointer",
    marginBottom: 10,
    marginLeft: indent2,
    marginTop: 10,
};

const menuDividerStyle = {
    marginBottom: 5,
    marginTop: 5,
};

class HLAppSideBar extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        appState: PropTypes.object,
        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
        sideBarOpen: PropTypes.bool,
        onSideBarArrowClick: PropTypes.func,
        sideBarWidthOpen: PropTypes.number,
        sideBarWidthClosed: PropTypes.number,
        showAboutDialog: PropTypes.bool,
        onShowAboutDialogChange: PropTypes.func,
    };

    static defaultProps = {
        appState: {},
        pageID: 0,
        onPageChange: () => console.log("onPageChange"),
        sideBarOpen: false,
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),
        sideBarWidthOpen: 0,
        sideBarWidthClosed: 0,
        showAboutDialog: false,
        onShowAboutDialogChange: () => console.log("onShowAboutDialogChange"),
    };

    //==================================================================================================================
    //
    //                                              Utility Functions
    //
    //==================================================================================================================

    getArrow = (pageID) => {
        return this.props.pageID === pageID ? (
            <ArrowIcon
                style={{
                    display: "inline-block",
                    marginLeft: indent2,
                }}
            />
        ) : (
            undefined
        );
    };

    getListItemStyle = (listItemEnabledBool, pageIDStr) => {
        let style;

        if (listItemEnabledBool) {
            if (this.props.pageID === pageIDStr) {
                style = Theme.styles.listItemSelectedLab;
            } else {
                style = Theme.styles.listItemLab;
            }
        } else {
            style = Theme.styles.listItemDisabledLab;
        }

        return style;
    };

    getStyledParagraph = (idStr, option1Str, option2Str, selectedOptionByte, marginLeftNum, onClickEvent) => {
        if (typeof marginLeftNum === "undefined") {
            marginLeftNum = 0;
        }

        let option1Item;
        let option2Item;

        if (selectedOptionByte === 1) {
            option1Item = (
                <strong
                    style={{
                        color: Theme.HL_SecondaryColor,
                    }}
                >
                    {option1Str}
                </strong>
            );

            option2Item = option2Str;
        } else {
            option1Item = option1Str;

            option2Item = (
                <strong
                    style={{
                        color: Theme.HL_SecondaryColor,
                    }}
                >
                    {option2Str}
                </strong>
            );
        }

        return (
            <p id={idStr} onClick={onClickEvent} style={menuItemStyle}>
                {option1Item} | {option2Item}
            </p>
        );
    };

    getMenuItemName = (form) => {
        let menuItemName;

        switch (form) {
            case HLConst.introForm:
                menuItemName = HLConst.introAreaText;
                break;

            case HLConst.stepByStepForm:
                menuItemName = HLConst.stepByStepAreaText;
                break;

            case HLConst.step1Form:
                menuItemName = HLConst.step1AreaText1 + " " + HLConst.step1AreaText2;
                break;

            case HLConst.step2Form:
                menuItemName = HLConst.step2AreaText1 + " " + HLConst.step2AreaText2;
                break;

            case HLConst.step3Form:
                menuItemName = HLConst.step3AreaText1 + " " + HLConst.step3AreaText2;
                break;

            case HLConst.step4Form:
                menuItemName = HLConst.step4AreaText1 + " " + HLConst.step4AreaText2;
                break;

            case HLConst.step5Form:
                menuItemName = HLConst.step5AreaText1 + " " + HLConst.step5AreaText2;
                break;

            case HLConst.step6Form:
                menuItemName = HLConst.step6AreaText1 + " " + HLConst.step6AreaText2;
                break;

            case HLConst.step7Form:
                menuItemName = HLConst.step7AreaText1 + " " + HLConst.step7AreaText2;
                break;

            case HLConst.FAQsHelpForm:
                menuItemName = HLConst.FAQsHelpAreaText;
                break;

            default:
                menuItemName = "";
                break;
        }

        return menuItemName;
    };

    getMenuItemOnClickEvent = (form) => {
        let menuItemOnClickEvent;

        const props = this.props;
        const onPageChange = props.onPageChange;

        const stdOnClickEvent = () => onPageChange(form);
        // const emptyOnClickEvent = () => {};

        // if (form === HLConst.homePageForm) {

        menuItemOnClickEvent = stdOnClickEvent;

        // }

        return menuItemOnClickEvent;
    };

    getMenuItemDisabledStyle = (form) => {
        let menuItemDisabledStyle;

        // const onPageChange = props.onPageChange;

        // const stdDisabledStyle = {
        //     color: Theme.darkGrayColor,
        //     cursor: "arrow",
        // };
        const emptyDisabledStyle = {};

        if (form === HLConst.homePageForm) {
            menuItemDisabledStyle = emptyDisabledStyle;
        }

        return menuItemDisabledStyle;
    };

    getMenuItemBox = (form) => {
        let menuItemBox;

        const props = this.props;
        const pageID = props.pageID;
        const sideBarOpen = props.sideBarOpen;
        // const onPageChange = props.onPageChange;

        // const appState = props.appState;

        let firstItemStyle = {};

        /* These depend on whether or not the user selected a mode yet. */
        const menuItemDisabledStyle = this.getMenuItemDisabledStyle(form);
        const menuItemOnClickEvent = this.getMenuItemOnClickEvent(form);

        let arrow = null;
        let menuItem = null;

        if (sideBarOpen) {
            let activePageStyle = {};

            if (pageID === form) {
                activePageStyle = {
                    marginLeft: 10,
                };
            }

            arrow = this.getArrow(form, firstItemStyle);
            menuItem = (
                <p
                    disabled={false}
                    key={form + "MenuItem"}
                    onClick={menuItemOnClickEvent}
                    style={{
                        color: Theme.HL_SecondaryColor,
                        ...menuItemStyle,
                        ...Theme.textFontStyle,
                        ...menuItemDisabledStyle,
                        ...activePageStyle,
                    }}
                >
                    {this.getMenuItemName(form)}
                </p>
            );
        }

        let menuItemBoxContents = [];
        menuItemBoxContents.push(arrow);
        menuItemBoxContents.push(menuItem);

        menuItemBox = (
            <TBox
                content={menuItemBoxContents}
                key={form + "Box"}
                justifyContent={"flex-start"}
                style={{
                    padding: 0,
                }}
            />
        );

        return menuItemBox;
    };

    onAboutBtnClick = () => {
        this.props.onShowAboutDialogChange(true);
    };

    onAboutDialogClose = () => {
        this.props.onShowAboutDialogChange(false);
    };

    onLivesSavedLinkClick = () => {
        window.open("https://www.livessavedtool.org/");
    };

    onHumanitarianHealthLinkClick = () => {
        window.open("http://hopkinshumanitarianhealth.org/");
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        /* Props */
        const props = this.props;
        // const appState = props.appState;
        const sideBarOpen = props.sideBarOpen;
        const sideBarWidthClosed = props.sideBarWidthClosed;
        const sideBarWidthOpen = props.sideBarWidthOpen;
        // const onSideBarArrowClick = props.onSideBarArrowClick;
        // const pageID = props.pageID;

        // let transformStr = "";
        // let arrowMarginLeft = 5;
        // if (sideBarOpen) {
        //
        //     transformStr = "rotate(180deg)";
        //     arrowMarginLeft = 0;
        //
        // }

        // const enabled = true;

        // const arrowBtn =
        //     <IconButton
        //         onClick = {() => onSideBarArrowClick()}
        //         style   = {{
        //             color      : Theme.HL_SecondaryColor,
        //             cursor     : "pointer",
        //             display    : "block",
        //             left       : "calc(100% - 38px)",
        //             marginLeft : arrowMarginLeft,
        //             marginTop  : 30,
        //             padding    : 0,
        //             zIndex     : 100,
        //         }}
        //     >
        //         <PlayArrow
        //              style = {{
        //                  color      : Theme.HL_SecondaryColor,
        //                  fontSize   : 25,
        //                  fontWeight : "bold",
        //                  transform  : transformStr,
        //              }}
        //         />
        //     </IconButton>;

        const welcomeBox = this.getMenuItemBox(HLConst.welcomeForm);
        const introBox = this.getMenuItemBox(HLConst.introForm);
        let divider1 = null;
        if (sideBarOpen) {
            divider1 = <Divider style={menuDividerStyle} />;
        }
        const stepByStepBox = this.getMenuItemBox(HLConst.stepByStepForm);
        const step1Box = this.getMenuItemBox(HLConst.step1Form);
        const step2Box = this.getMenuItemBox(HLConst.step2Form);
        const step3Box = this.getMenuItemBox(HLConst.step3Form);
        const step4Box = this.getMenuItemBox(HLConst.step4Form);
        const step5Box = this.getMenuItemBox(HLConst.step5Form);
        const step6Box = this.getMenuItemBox(HLConst.step6Form);
        const step7Box = this.getMenuItemBox(HLConst.step7Form);
        const FAQsHelpBox = this.getMenuItemBox(HLConst.FAQsHelpForm);
        let divider2 = null;
        if (sideBarOpen) {
            divider2 = <Divider style={menuDividerStyle} />;
        }

        // const resourcesLab =
        //     <TLabel
        //         caption = {"Resources"}
        //         onClick = {() => alert("Coming soon.")}
        //         style   = {{
        //             ...menuItemStyle,
        //             ...Theme.textFontStyle,
        //             color        : Theme.HL_SecondaryColor,
        //             marginBottom : 20,
        //         }}
        //     />;

        // const aboutLab =
        //     <TLabel
        //         caption = {"About"}
        //         onClick = {this.onAboutBtnClick}
        //         style   = {{
        //             ...menuItemStyle,
        //             ...Theme.textFontStyle,
        //             color        : Theme.HL_SecondaryColor,
        //             marginBottom : 20,
        //         }}
        //     />;

        // const imagesDivider = (
        //     <Divider
        //         style={{
        //             ...Theme.dividerStyle,
        //         }}
        //     />
        // );

        let divider3 = null;
        if (sideBarOpen) {
            divider3 = <Divider style={menuDividerStyle} />;
        }

        const livesSavedLink = (
            <Link
                onClick={this.onLivesSavedLinkClick}
                key={"livesSavedLink"}
                style={{
                    ...menuItemStyle,
                    ...Theme.textFontStyle,
                    color: Theme.HL_SecondaryColor,
                    display: "block",
                    marginBottom: 20,
                }}
                underline={"hover"}
            >
                The Lives Saved Tool
            </Link>
        );

        const centerHumanitarianHealthLink = (
            <Link
                onClick={this.onHumanitarianHealthLinkClick}
                key={"centerHumanitarianHealthLink"}
                style={{
                    ...menuItemStyle,
                    ...Theme.textFontStyle,
                    color: Theme.HL_SecondaryColor,
                    display: "block",
                    marginBottom: 20,
                }}
                underline={"hover"}
            >
                Center for Humanitarian Health
            </Link>
        );

        // let aboutDialog = null;
        //
        // if (this.props.showAboutDialog) {
        //
        //     const aboutHLiSTLab =
        //         <TLabel
        //             caption = {"About H-LiST"}
        //             key     = {"aboutHLiSTLab"}
        //             style   = {{
        //                 ...Theme.pageHeadingFontStyle,
        //                 marginBottom : Theme.topIndent,
        //             }}
        //         />;
        //
        //     const aboutDivider =
        //         <Divider
        //             style = {{
        //                 ...Theme.dividerStyle,
        //             }}
        //         />;
        //
        //     const HumanitarianHealthLogoBlueTextVertical_Img =
        //         <div
        //             key   = {"HumanitarianHealthLogoBlueTextVertical_Div"}
        //             style = {{
        //                 display        : "flex",
        //                 justifyContent : "center",
        //                 width          : "100%",
        //             }}
        //         >
        //             <img
        //                 alt   = ""
        //                 key   = {"HumanitarianHealthLogoBlueTextVertical_Img"}
        //                 src   = {HumanitarianHealthLogoBlueTextVertical}
        //                 style = {{
        //                     minWidth : 275,
        //                     width    : 275,
        //                 }}
        //             />
        //         </div>;
        //
        //     const aboutLab =
        //         <TLabel
        //             caption ={
        //                 "H-LiST was developed by the Center for Humanitarian Health at Johns Hopkins University, in " +
        //                 "collaboration with the Lives Saved Tool (LiST) team and UNHCR. It is supported by the " +
        //                 "Bill & Melinda Gates Foundation."
        //             }
        //             key   = {"aboutLab"}
        //             style = {{
        //                 ...Theme.textFontStyle,
        //                 marginBottom : 20,
        //             }}
        //         />;
        //
        //     const creditsText =
        //         <p
        //             style = {{
        //                 color          : Theme.HL_SecondaryColor,
        //                 ...Theme.labelFontStyle,
        //                 fontSize       : 18,
        //             }}
        //         >
        //             Credits
        //         </p>;
        //
        //     const introPageText =
        //         <p
        //             style = {{
        //                 ...Theme.textFontStyle,
        //             }}
        //         >
        //             2009-272, Introduction page picture
        //         </p>;
        //
        //     const introPageImgDescText =
        //         <p
        //             style = {{
        //                 ...Theme.textFontStyle,
        //             }}
        //         >
        //             A woman carries a water container at Al Kharaz Refugee Camp, Yemen.
        //
        //             <br/>
        //             © 2009 Micah Albert, Courtesy of Photoshare
        //         </p>;
        //
        //     let dialogContent = [
        //         <div>
        //             {aboutHLiSTLab}
        //             {aboutDivider}
        //             {HumanitarianHealthLogoBlueTextVertical_Img}
        //             {aboutLab}
        //             {imagesDivider}
        //             {creditsText}
        //             {introPageText}
        //             {introPageImgDescText}
        //         </div>
        //     ];
        //     // dialogContent.push(HumanitarianHealthLogoBlueTextVertical_Img);
        //     // dialogContent.push(aboutLab);
        //     //dialogContent.push(welcomePageText);
        //     // dialogContent.push(creditText);
        //
        //     aboutDialog =
        //         <TDialog
        //             actions = {["mrClose"]}
        //             onClose = {this.onAboutDialogClose}
        //             content = {dialogContent}
        //             key     = {"aboutDialog"}
        //         />;
        //
        // }

        return (
            <TSideDrawer
                direction="left"
                expanded={sideBarOpen}
                header={false}
                style={{
                    // backgroundColor : Theme.whiteColor,// markThomas
                    backgroundColor: Theme.lightGrayColor,
                    height: "100%", //"auto !important",// markThomas
                    bottom: "auto", // markThomas
                }}
                widthClosed={sideBarWidthClosed}
                widthOpen={sideBarWidthOpen}
            >
                {/*{arrowBtn}*/}

                {welcomeBox}
                {introBox}
                {divider1}
                {stepByStepBox}
                {step1Box}
                {step2Box}
                {step3Box}
                {step4Box}
                {step5Box}
                {step6Box}
                {step7Box}
                {divider2}
                {FAQsHelpBox}
                {/*{aboutLab}*/}
                {/*{aboutDialog}*/}
                {divider3}
                {livesSavedLink}
                {centerHumanitarianHealthLink}
            </TSideDrawer>
        );
    }
}

export default HLAppSideBar;
